import {GuideFeature} from './guide-feature';
import {Guide} from '../shared/guide';

export class HydratedGuideFeature {
  public guideFeature: GuideFeature;
  public guides: Guide[];
}
